import Vue from 'vue'
import App from './App.vue'
import state from '@/state'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false

new Vue({
  vuetify,
  store: state,
  render: h => h(App)
}).$mount('#app')
